import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

//import ButtonComponent from "../../../components/common/button/Button";
//import DataTablePagination from "../../../components/common/datatable/DataTablePagination";
import ButtonComponent from "../../../components/common/button/Button";
import DataTablePagination from "../../../components/common/datatable/DataTablePagination";
const DataDetails = (props) => {
  const priceMemoData = useSelector(
    (state) => state?.piceMemoData
  );
  const [disableFilterBtn, setDisableFilterBtn] = useState(true);
  const [filteredTotalItems, setFilteredTotalItems] = useState(priceMemoData?.data?.totalNumberOfItems);
  const [filteredTotalColumn, setFilteredTotalColumn] = useState(0);
  const [isGridReady, setIsGridReady] = useState(false);
  const [columnState, setColumnState] = useState(null);
  const [selectedColumn, setSelectedColumn] = useState('');

  const handlePostFilterChanged = (filteredCount, totalCount) => {
    setFilteredTotalItems(filteredCount); // Update the filtered total items
  };

  const isInvalidValue = (value) => {
    return value === null || value === undefined || value === "" || value === "-";
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "-";
    return dayjs(timestamp).format("DD-MMM-YYYY HH:mm:ss");
  };

  const renderExpandableText = (params, maxLength = 50) => {
    const text = params.value || ""; // The error details text
    const isLongText = text.length > maxLength;

    // Initialize the showFullText property for the row if not already set
    if (!params.node.showFullText) {
      params.node.showFullText = false;
    }

    const toggleText = () => {
      params.node.showFullText = !params.node.showFullText;
      params.api.refreshCells({ rowNodes: [params.node], force: true }); // Refresh the cell to update the UI
    };

    return isLongText ? (
      <div>
        {params.node.showFullText ? (
          <>
            <span>{text}</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              Less
            </button>
          </>
        ) : (
          <>
            <span>{text.substring(0, maxLength)}...</span>{" "}
            <button
              onClick={toggleText}
              style={{
                background: "none",
                border: "none",
                color: "#181d1f",
                cursor: "pointer",
                textDecoration: "underline",
                fontWeight: "bold",
              }}
            >
              More
            </button>
          </>
        )}
      </div>
    ) : (
      <span>{text}</span>
    );
  };

  const columnData = useMemo(() => {
    if(props.data.sisPriceMemo) {
      return [
        
        {
          headerName: 'Ingredient/SCode',
          field: "ingredient",
          sortable: true,
          resizable: false,
          pinned: "left",
          unSortIcon: true,
          width: 150,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('ingredient')
          }
        },
        
        {
          headerName: 'Plant Number',
          field: "sapPlantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: (params) => params?.data?.status?.toLowerCase().includes("contract submitted") ? false : true,
          cellEditor: "agTextCellEditor",
          cellClass: "cpsComments-cell",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "sapPlantId"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "sapPlantId"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, sapPlantId: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                <EditIcon fontSize="sm" />
              </div>
            );
          },
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('sapPlantId'),
            "red-cell": (params) => {
                const value = params.value ? params.value.toString().trim() : "";
                return !value || value === "-";
              },
          }
        },
        {
          headerName: 'Plant Description',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('plantName')
          }
        },
        
        {
          headerName: 'Supplier Number/Vendor Number',
          field: "sapSupplierId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: (params) => params?.data?.status?.toLowerCase().includes("contract submitted") ? false : true,
          cellEditor: "agTextCellEditor",
          cellClass: "cpsComments-cell",
          
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "sapSupplierId"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "sapSupplierId"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, sapSupplierId: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                <EditIcon fontSize="sm" />
              </div>
            );
          },
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('sapSupplierId'),
            "red-cell": (params) => {
                const value = params.value ? params.value.toString().trim() : "";
                return !value || value === "-";
              },
          },
          cellRenderer: (params) => renderExpandableText(params, 100)
        },
        {
          headerName: 'Supplier Description',
          field: "sapSupplierDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('sapSupplierDescription')
          }
        },
        {
          headerName: 'Supplier',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('supplierName')
          }
        },
        {
          headerName: 'Supplier Country',
          field: "facilitycountry",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('facilitycountry')
          }
        },
        {
          headerName: 'Material Number',
          field: "sapMaterialNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          editable: (params) => params?.data?.status?.toLowerCase().includes("contract submitted") ? false : true,
          cellEditor: "agTextCellEditor",
          cellClass: "cpsComments-cell",
          // onCellValueChanged: (params) =>
          //   props.handleCellValueChange(params, "sapMaterialNumber"),
          // valueSetter: (params) =>
          //   props.handleCellValueChange(params, "sapMaterialNumber"),
          valueSetter: (params) => {
            if (params.newValue !== params.oldValue) {
              const dataCopy = { ...params.data, sapMaterialNumber: params.newValue };
              params.node.setData(dataCopy);
              return true;
            }
            return false;
          },
          cellRenderer: (params) => {
            return (
              <div className="cps-comments-icon">
                <span style={{ flex: 1, padding: "0px 4px" }}>
                  {params.value}{" "}
                </span>
                <EditIcon fontSize="sm" />
              </div>
            );
          },
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('sapMaterialNumber'),
            // "red-cell": (params) => {
            //     const value = params.value ? params.value.toString().trim() : "";
            //     return !value || value === "-";
            //   },
            "red-cell": (params) => isInvalidValue(params.value),
          }
        },
        {
          headerName: 'Material Description',
          field: "sapMaterialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('sapMaterialDescription')
          }
        },
        {
          headerName: 'Pack Size',
          field: "packSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('packSize')
          }
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('uom')
          }
        },
        {
          headerName: 'Price',
          field: "pricePerKG",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('pricePerKG')
          }
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('currency')
          }
        },
        {
          headerName: 'Price Effective from Date',
          field: "effectiveStartDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('effectiveStartDate')
          }
        },
        {
          headerName: 'Price Effective to Date',
          field: "effectiveEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('effectiveEndDate')
          }
        },
        {
          headerName: 'Allocation Quantity',
          field: "allocationQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('allocationQty')
          }
        },
        {
          headerName: 'From (Qty)',
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('fromQty')
          }
        },
        {
          headerName: 'To (Qty)',
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('toQty')
          }
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50),
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('moqComments')
          }
        },
        {
          headerName: 'Manufacturing Lead Time',
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('manufacturingLeadTime')
          }
        },
        {
          headerName: 'Inco Terms',
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('incoterms')
          }
        },
        {
          headerName: 'Named Place',
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('namedPlace')
          }
        },
        {
          headerName: 'Status',
          pinned: "right",
          valueGetter: () => 'Pending for Modify in Maintenance',
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('status')
          }
        }
      ]
    } else if (props.data.agriPriceMemo) {
      return [
        {
          headerName: 'Is New',
          field: "isNew",
          sortable: true,
          resizable: false,
          filterParams: {
            textFormatter: (value) => {
              if (typeof value === "string") {
                const v = value.trim().toLowerCase();
                if (v === "!") return "!";
                if (v === "-") return "-";
                return v;
              }
              return value;
            },
          },
          valueGetter: (params) => {
            if (params.data?.isNew === true) return "!";
            if (params.data?.isNew === false) return "-";
            return "";
          },
          valueFormatter: (params) => params.value,
          cellRenderer: (params) => {
            if (params.value === "!") {
              return (
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  !
                </span>
              );
            }
            if (params.value === "-") {
              return (
                <span
                  style={{
                    color: "#616161",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  -
                </span>
              );
            }
            return "";
          },
          pinned: "left",
          unSortIcon: true,
          width: 130,
        },
        {
          headerName: 'Plant Id',
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('plantId')
          }
        },
        {
          headerName: 'Vendor Number',
          field: "vendorNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('vendorNumber')
          }
        },
        {
          headerName: 'Material Number',
          field: "materialNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('materialNumber')
          }
        },
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('plantName')
          }
        },
        {
          headerName: 'Supplier',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('supplierName')
          }
        },
        {
          headerName: 'Material Description',
          field: "materialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('materialDescription')
          }
        },
        {
          headerName: 'S No.',
          field: "snumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('snumber')
          }
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('currency')
          }
        },
        {
          headerName: 'Volume',
          field: "volume",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('volume')
          }
        },
        {
          headerName: 'Group',
          field: "groupAgri",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('groupAgri')
          }
        },
        {
          headerName: 'Sub Category',
          field: "subCategory",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('subCategory')
          }
        },
        {
          headerName: 'Brand',
          field: "brand",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('brand')
          }
        },
        {
          headerName: 'Prorement Manager',
          field: "prorementManager",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('prorementManager')
          }
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('uom')
          }
        },
        {
          headerName: 'Geography',
          field: "geography",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('geography')
          }
        },
        {
          headerName: 'Picasso Approval',
          field: "picassoApproval",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('picassoApproval')
          }
        },
        {
          headerName: 'Material Origin',
          field: "materialOrigin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('materialOrigin')
          }
        },
        {
          headerName: 'LeadTime',
          field: "leadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('leadTime')
          }
        },
        {
          headerName: 'Ship From Country',
          field: "shipFromCountry",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('shipFromCountry')
          }
        },
        {
          headerName: 'Ship From City',
          field: "shipFromCity",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('shipFromCity')
          }
        },
        {
          headerName: 'Payment Term',
          field: "paymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('paymentTerm')
          }
        },
        {
          headerName: 'Material Cost Per UOM',
          field: "materialCostPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('materialCostPerUOM')
          }
        },
        {
          headerName: 'Total Cost Per UOM',
          field: "totalCostPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('totalCostPerUOM')
          }
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50),
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('moqComments')
          }
        },
        {
          headerName: 'RFA Ft Per UOM',
          field: "rfaFtPerUOM",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('rfaFtPerUOM')
          }
        },
        {
          headerName: 'Bid Incoterm',
          field: "bidIncoterm",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('bidIncoterm')
          }
        },
        // {
        //   headerName: 'Open PO',
        //   field: "openPO",
        //   sortable: true,
        //   resizable: false,
        //   filterParams: commonFilterParams,
        //   filter: commonFilter,
        //   suppressMovable: true,
        //   unSortIcon: true,
        //   cellClassRules: {
        //     'bold-cell': (params) => params.data.changedFieldNames?.includes('openPO')
        //   }
        // },
        {
          headerName: 'Bid Incoterm Location',
          field: "bidIncotermLocation",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('bidIncotermLocation')
          }
        },
        {
          headerName: 'Price Effective Date',
          field: "priceEffectiveDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('priceEffectiveDate')
          }
        },
        {
          headerName: 'Price EndDate',
          field: "priceEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('priceEndDate')
          }
        },
        {
          headerName: 'Packaging Size',
          field: "packagingSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('packagingSize')
          }
        },
        {
          headerName: 'Forecast',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('foreCastFile')
          }
        },
        {
          headerName: 'Status',
          pinned: "right",
          field: "status",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('status')
          }
        },
        {
          headerName: 'Reject',
          pinned: "right",
          field: "reject",
          sortable: false,
          resizable: false,
          unSortIcon: true,
          filter: false,
          width: 120,
          cellRenderer: (params) => (
            <ButtonComponent
              maxWidth="100px"
              label="Reject"
              bgColor="black"
              color="white"
              disabled={params?.data?.status?.toLowerCase().includes("contract submitted") ? true : false}
              onClick={() => props.rejectHandler(params?.data?.runOutputSeqId)}
            />
          ),
        }
      ]
    } else if (props.data.packagingPriceMemo) {
      return [
        {
          headerName: 'Plant Id',
          field: "plantId",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('plantId')
          }
        },
        {
          headerName: 'Vendor Number',
          field: "vendorNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('vendorNumber')
          }
        },
        {
          headerName: 'Supplier Item No',
          field: "supplierItemNo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('supplierItemNo')
          }
        },
        {
          headerName: 'CC Material No',
          field: "ccMaterialNo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('ccMaterialNo')
          }
        },
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('plantName')
          }
        },
        {
          headerName: 'Supplier',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('supplierName')
          }
        },
        {
          headerName: 'Material Description',
          field: "materialDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('materialDescription')
          }
        },
        {
          headerName: 'Year',
          field: "yearPckg",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('yearPckg')
          }
        },
        {
          headerName: 'Division',
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('division')
          }
        },
        {
          headerName: 'Location Name',
          field: "locationName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('locationName')
          }
        },
        {
          headerName: 'Manager',
          field: "managerName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('managerName')
          }
        },
        {
          headerName: 'Last Change',
          field: "lastChange",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('lastChange')
          }
        },
        {
          headerName: 'Payment Description',
          field: "paymentDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('paymentDescription')
          }
        },
        {
          headerName: 'Price',
          field: "price",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('price')
          }
        },
        {
          headerName: 'Supplier Description',
          field: "supplierDescription",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('supplierDescription')
          }
        },
        {
          headerName: 'Material Type',
          field: "materialType",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('materialType')
          }
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('currency')
          }
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('uom')
          }
        },
        {
          headerName: 'Inco Terms',
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('incoterms')
          }
        },
        {
          headerName: 'Named Place',
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('namedPlace')
          }
        },
        {
          headerName: 'From (Qty)',
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('fromQty')
          }
        },
        {
          headerName: 'To (Qty)',
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('toQty')
          }
        },
        {
          headerName: 'Effective From',
          field: "effectiveStartDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('effectiveStartDate')
          }
        },
        {
          headerName: 'Effective To',
          field: "effectiveEndDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('effectiveEndDate')
          }
        },
        {
          headerName: 'Sap Payment Term',
          field: "sapPaymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('sapPaymentTerm')
          }
        },
        {
          headerName: 'Manufacturing Lead Time',
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('manufacturingLeadTime')
          }
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50),
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('moqComments')
          }
        },
        // {
        //   headerName: 'Open PO',
        //   field: "openPO",
        //   sortable: true,
        //   resizable: false,
        //   filterParams: commonFilterParams,
        //   filter: commonFilter,
        //   suppressMovable: true,
        //   unSortIcon: true,
        //   cellClassRules: {
        //     'bold-cell': (params) => params.data.changedFieldNames?.includes('openPO')
        //   }
        // },
        {
          headerName: 'Allocation Quantity',
          field: "allocationQty",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          cellClass: "status-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('allocationQty')
          }
        },
        {
          headerName: 'Allocation Notes',
          field: "allocationNotes",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('allocationNotes')
          }
        },
        {
          headerName: 'Forecast',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('foreCastFile')
          }
        },
        {
          headerName: 'Status',
          pinned: "right",
          field: "status",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellClassRules: {
            'bold-cell': (params) => params.data.changedFieldNames?.includes('status')
          }
        },
        {
          headerName: 'Reject',
          pinned: "right",
          field: "reject",
          sortable: false,
          resizable: false,
          width: 120,
          filter: false,
          unSortIcon: true,
          cellRenderer: (params) => (
            <ButtonComponent
              maxWidth="100px"
              label="Reject"
              bgColor="black"
              color="white"
              disabled={params?.data?.status?.toLowerCase().includes("contract submitted") ? true : false}
              onClick={() => props.rejectHandler(params?.data?.runOutputSeqId)}
            />
          ),
        },
      ]
    } else if (props.data.cepgPriceMemo) {
      return [
        {
          headerName: 'Is New',
          field: "isNew",
          sortable: true,
          resizable: false,
          filterParams: {
            textFormatter: (value) => {
              if (typeof value === "string") {
                const v = value.trim().toLowerCase();
                if (v === "!") return "!";
                if (v === "-") return "-";
                return v;
              }
              return value;
            },
          },
          valueGetter: (params) => {
            if (params.data?.isNew === true) return "!";
            if (params.data?.isNew === false) return "-";
            return "";
          },
          valueFormatter: (params) => params.value,
          cellRenderer: (params) => {
            if (params.value === "!") {
              return (
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "20px",
                    textAlign: "center",
                  }}
                >
                  !
                </span>
              );
            }
            if (params.value === "-") {
              return (
                <span
                  style={{
                    color: "#616161",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                >
                  -
                </span>
              );
            }
            return "";
          },
          pinned: "left",
          unSortIcon: true,
          width: 130,
        },
        {
          headerName: 'Plant Id',
          field: "plant",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Plant Name',
          field: "plantName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Number',
          field: "material",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Package Size',
          field: "packSize",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'S-Code',
          field: "scode",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Year',
          field: "year",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Division',
          field: "division",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Forecast File',
          field: "foreCastFile",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Manager',
          field: "manager",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier Name',
          field: "supplierName",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Supplier Number',
          field: "supplierNumber",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Supplier Description',
          field: "description",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Gmp Lead',
          field: "gmpLead",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Change Date',
          field: "changeDate",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Inco Terms',
          field: "incoterms",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Named Place',
          field: "namedPlace",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Price',
          field: "price",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Material Type',
          field: "material",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Currency',
          field: "currency",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'UOM',
          field: "uom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'From (Qty)',
          field: "fromQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'To (Qty)',
          field: "toQty",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective From',
          field: "effectiveFrom",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Effective To',
          field: "effectiveTo",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'PIN',
          field: "pin",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Alocation Quantity',
          field: "allocationQtyKg",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Allocation Notes',
          field: "allocationNotes",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Sap Payment Term',
          field: "paymentTerm",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Picasso Facility',
          field: "picassoFacility",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "paymentTerms-cell",
        },
        {
          headerName: 'Manufacturing Lead Time',
          field: "manufacturingLeadTime",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'MOQ Comments',
          field: "moqComments",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Error Details',
          field: "errorDetails",
          sortable: true,
          resizable: false,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
          cellRenderer: (params) => renderExpandableText(params, 50)
        },
        {
          headerName: 'Open PO',
          field: "openPO",
          sortable: true,
          resizable: false,
          unSortIcon: true,
        },
        {
          headerName: 'Status',
          field: "status",
          sortable: true,
          resizable: true,
          unSortIcon: true,
          initialWidth: 180,
          wrapText: true,
          autoHeight: true,
          cellClass: "status-cell",
        },
        {
          headerName: 'Reject',
          pinned: "right",
          field: "reject",
          sortable: false,
          resizable: false,
          width: 120,
          filter: false,
          unSortIcon: true,
          cellRenderer: (params) => (
            <ButtonComponent
              maxWidth="100px"
              label="Reject"
              bgColor="black"
              color="white"
              disabled={params?.data?.status?.toLowerCase().includes("contract submitted") ? true : false}
              onClick={() => props.rejectHandler(params?.data?.runOutputSeqId)}
            />
          ),
        },
      ]
    }
  }, [props.data])

  const selectionColumnDef = useMemo(() => ({
    pinned: "left",
  }), []);

  const gridApiRef = useRef(null); // Reference to the grid API

  
  const onColumnChange = e => {
    const col = e.target.value;
    setSelectedColumn(col);
    if (col && gridApiRef.current) {
      gridApiRef.current.ensureColumnVisible(col);
    }
  };

  const onGridReady = (params) => {
    gridApiRef.current = params.api; // Store the grid API instance
    setIsGridReady(true);
    if (columnState) {
      params.columnApi.applyColumnState({ state: columnState, applyOrder: true });
    }
  };

  useEffect(() => {
      // Restore filter model from localStorage on component mount
      if (isGridReady && gridApiRef?.current) {
        const savedFilterModel = localStorage.getItem("priceMemoFilterModel");
        if (savedFilterModel) {
          gridApiRef.current.setFilterModel(JSON.parse(savedFilterModel));
          setDisableFilterBtn(true); // Enable the "Clear All Filters" button
        }
      }
    }, [isGridReady]);

  const clearAllFilters = () => {
    if (gridApiRef.current) {
      gridApiRef.current.setFilterModel(null); // Clear all filters
      localStorage.removeItem("priceMemoFilterModel");
      setDisableFilterBtn(true);
    }
  };

  const onFilterChanged = (params) => {
    if (gridApiRef.current) {
      const filterModel = gridApiRef.current.getFilterModel();
      setDisableFilterBtn(Object.keys(filterModel).length === 0); // Enable button if filters exist
      setFilteredTotalColumn(Object.keys(filterModel).length);

      const filteredRowCount = params.api.getDisplayedRowCount();
      localStorage.setItem("priceMemoFilterModel", JSON.stringify(filterModel));
      setFilteredTotalItems(filteredRowCount);
    }
  };

  const onColumnMoved = useCallback((params) => {
    if (params && params.columnApi && typeof params.columnApi.getColumnState === "function") {
      setColumnState(params.columnApi.getColumnState());
    }
  }, []);

  const gridOptions = {
    getRowId: (params) => {
      return `${params?.data?.runOutputSeqId}`;
    },
    overlayLoadingTemplate: `<span class="ag--overlay-loading-center" >Please wait while data is loading</span>`,
    overlayNoRowsTemplate: `<span class="ag--overlay-no-rows-center" >No Data Available</span>`,
    defaultColDef: {
      sortable: true,
      filter: 'agMultiColumnFilter',
      autoHeight: true,
      cellStyle: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        lineHeight: 1.5,
        display: "flex",
        alignItems: "center",
      },
      valueGetter: (params) => {
        if (!params.data) return "-";

        const field = params.colDef.field;
        const value = params.data[field];

        return value === null || value === undefined || value === ""
          ? "-"
          : value;
      },
    },
    onColumnMoved,
    onFilterChanged,
  };

  return (
    <>
      <div style={{display: 'flex', marginBottom: '20px', justifyContent: 'space-between', alignItems: 'center'}}>
        <FormControl sx={{ m: 1, minWidth: 200 }} size="small">
          <InputLabel>Jump to Column</InputLabel>
          <Select
            id="col-select"
            value={selectedColumn}
            label="Jump to Column"
            onChange={onColumnChange}
          >
            <MenuItem value="">Select Column</MenuItem>
            {columnData?.map(col => (
              <MenuItem key={col?.field} value={col?.field}>
                {col?.headerName || col?.field}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <ButtonComponent
          maxWidth="150px"
          label="Clear All Filters"
          bgColor="black"
          color="white"
          disabled={disableFilterBtn}
          onClick={clearAllFilters}
        />
      </div>
      <DataTablePagination
        columns={columnData}
        rows={props?.data?.sisPriceMemo ||
          props?.data?.agriPriceMemo ||
          props?.data?.packagingPriceMemo ||
          props?.data?.cepgPriceMemo || []}
        onPageSizeChanged={props.onPageSizeChanged}
        // enableCheckbox={false}
        onRowSelected={props.onRowSelected}
        onSelectionChanged={props.onSelectionChanged}
        rowSelection={props.rowSelection}
        getRowStyle={props.getRowStyle}
        selectionColumnDef={selectionColumnDef}
        onCellValueChanged={props.handleCellValueChange}
        onGridReady={onGridReady}
        goToPage={props.goToPage}
        pageSize={props.pageSize}
        currentPage={props.currentPage}
        totalPages={props.totalPages}
        totalPageItems={filteredTotalItems}
        totalItemCurrentPage={props.totalItemCurrentPage}
        gridOptions={gridOptions}
        postFilterChanged={handlePostFilterChanged}
        filteredTotalColumn={filteredTotalColumn}
      />
    </>
  );
};

export default DataDetails;
